module.exports = __webpack_public_path__ + "static/media/candidaformula1.bac61f31.pdf";